import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import UserServices from './UserServices';
import UserPackages from './UserPackages';
import './AppointmentsTrai.css';
import translations from './lang/index';
import Appointments from './components/ServiceProfile/Appointments';
import ClientList from './ClientList';
import Vacations from './Vacations'; // <-- ÚJ

const AppointmentsTrai = () => {
  const language = localStorage.getItem('language') || 'ro';
  const t = translations[language];

  return (
    <div className="service-profile">
      {/* Subnav / Tabs */}
      <nav className="subnav" aria-label="Service profile sub navigation">
        <div className="subnav-inner">
          <NavLink
            to="Appointments"
            className={({ isActive }) => (isActive ? 'subtab active' : 'subtab')}
            end
          >
            <span className="subtab-label">
              <span className="l1">{t.subnav_appointments_l1}</span>
              <span className="l2">{t.subnav_appointments_l2}</span>
            </span>
          </NavLink>

          <NavLink
            to="UserServices"
            className={({ isActive }) => (isActive ? 'subtab active' : 'subtab')}
          >
            <span className="subtab-label">
              <span className="l1">{t.subnav_services_l1}</span>
              <span className="l2">{t.subnav_services_l2}</span>
            </span>
          </NavLink>

          <NavLink
            to="UserPackages"
            className={({ isActive }) => (isActive ? 'subtab active' : 'subtab')}
          >
            <span className="subtab-label">
              <span className="l1">{t.subnav_packages_l1}</span>
              <span className="l2">{t.subnav_packages_l2}</span>
            </span>
          </NavLink>

          {/* ÚJ: Szabadságok */}
          <NavLink
            to="Vacations"
            className={({ isActive }) => (isActive ? 'subtab active' : 'subtab')}
          >
            <span className="subtab-label">
              <span className="l1">{t.subnav_vacations_l1 || 'Szabadságok'}</span>
              <span className="l2">{t.subnav_vacations_l2}</span>
            </span>
          </NavLink>
          
          <NavLink
            to="ClientList"
            className={({ isActive }) => (isActive ? 'subtab active' : 'subtab')}
          >
            <span className="subtab-label">
              <span className="l1">{t.subnav_clients_l1}</span>
              <span className="l2">{t.subnav_clients_l2}</span>
            </span>
          </NavLink>
        </div>
      </nav>

      {/* Content */}
      <div className="profile-content">
        <Routes>
          <Route path="/" element={<Appointments />} />
          <Route path="Appointments" element={<Appointments />} />
          <Route path="UserServices" element={<UserServices />} />
          <Route path="UserPackages" element={<UserPackages />} />
          <Route path="Vacations" element={<Vacations />} /> {/* <-- ÚJ */}
          <Route path="ClientList" element={<ClientList />} />
        </Routes>
      </div>
    </div>
  );
};

export default AppointmentsTrai;
